import React from 'react';
import { CheckCircle2, Download } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DonateSuccess = ({ donation, onClose }) => {
  const { t } = useLanguage();
  return (
    <div className="jbss-donate-success" data-testid="donate-success">
      <CheckCircle2 size={48} className="jbss-donate-success-icon" />
      <div className="jbss-donate-receipt">
        <div><span>{t('donation.receiptNo')}</span><strong data-testid="donate-receipt-no">{donation.receipt_no}</strong></div>
        <div><span>{t('donation.amount')}</span><strong data-testid="donate-paid-amount">₹{donation.amount.toLocaleString('en-IN')}</strong></div>
        <div><span>{t('donation.name')}</span><strong>{donation.name}</strong></div>
      </div>
      <a className="jbss-btn jbss-btn-navy jbss-donate-submit" href={`${API}/donations/${donation.id}/receipt`}
        target="_blank" rel="noreferrer" data-testid="donate-download-receipt">
        <Download size={16} /><span>{t('donation.download')}</span>
      </a>
      <p className="jbss-donate-hint">{t('donation.messageNote')}</p>
      <button type="button" className="jbss-admin-link" onClick={onClose} data-testid="donate-close">{t('donation.close')}</button>
    </div>
  );
};
